import Collapse from '@anm/components/Collapse';
import { UploadFileProps } from '@anm/components/InputFile';
import Loader from '@anm/components/Loader';
import SelectionList from '@anm/components/list/SelectionList';
import NewLogo from '@anm/components/video-landings/NewLogo';
import SectionTitle from '@anm/components/video-landings/SectionTitle';
import useSwitchState from '@anm/hooks/useSwitchState';
import { FC } from 'react';

import BrandListModal, { BrandListModalProps } from './BrandListModal';
import { ItemWrapper, LoaderContainer, ModalButton, SectionListWrapper, Wrapper } from './Wrapper';

export type LogoItem = {
  name: string;
  iconSrc: string;
};

type SelectionLogoProps = BrandListModalProps & {
  list: LogoItem[] | null;
  selectedLogoIndex: number;
  isPendingUploadLogo: boolean;
  allowedImageExtensions: string;
  onChange(props: UploadFileProps): void;
  onListChange(props: LogoItem): void;
  onRemoveLogo: (id: string) => void;
  showChangeBrand?: boolean;
  isCollapseOpened?: boolean;
};

const LogoSelection: FC<SelectionLogoProps> = ({
  list,
  onChange,
  onListChange,
  onRemoveLogo,
  showChangeBrand = true,
  isCollapseOpened = false,
  selectedLogoIndex,
  isPendingUploadLogo,
  allowedImageExtensions,
  ...modalProps
}) => {
  const [isOpenModal, openModal, closeModal] = useSwitchState();
  const isCollapseActive = !!(list && list.length >= 4);
  const canOpenModal = !!modalProps.brandList?.length;

  return (
    <Wrapper>
      {showChangeBrand && (
        <ModalButton onClick={openModal} isDisabled={!canOpenModal} isRightAligned={!isCollapseActive}>
          Change brand
        </ModalButton>
      )}

      {isOpenModal && <BrandListModal onModalClose={closeModal} {...modalProps} />}
      <SectionListWrapper>
        <Collapse
          minHeight={72}
          isOpened={isCollapseOpened || selectedLogoIndex > 4}
          variant="up-down-small-arrow"
          isArrowHidden={isCollapseOpened || !isCollapseActive}
          isTargetClickable={!isCollapseOpened && isCollapseActive}
          renderTarget={() => <SectionTitle level={2} title="Logo" />}
          renderContent={() => (
            <SelectionList
              onChange={onListChange}
              newListItemIndex={selectedLogoIndex}
              selectedItemIndexes={[selectedLogoIndex]}
              onRemove={onRemoveLogo}
              list={[
                {
                  name: 'no-logo',
                  iconSrc: '',
                  renderContent: () => <ItemWrapper>No logo</ItemWrapper>
                },
                {
                  isSelectionDisabled: true,
                  renderContent: () => (
                    <ItemWrapper>
                      {isPendingUploadLogo ? (
                        <LoaderContainer>
                          <Loader size="small" color="gray" />
                        </LoaderContainer>
                      ) : (
                        <NewLogo accept={allowedImageExtensions} onUpload={onChange} />
                      )}
                    </ItemWrapper>
                  )
                },
                ...[...(list || [])]
              ]}
            />
          )}
        />
      </SectionListWrapper>
    </Wrapper>
  );
};

export default LogoSelection;
